// src/dust/index.ts
var BARE_TRANSFER_PROTOCOLS = /* @__PURE__ */ new Set([
  "native_transfer",
  "erc20",
  "erc721",
  "erc1155"
]);
var DEFAULT_DUST_USD = 0.01;
var DEFAULT_CAMPAIGN_MIN_RECIPIENTS = 10;
function dustReason(row, options = {}) {
  const floor = options.usdFloor ?? DEFAULT_DUST_USD;
  if (options.protectedIds && row.canonicalTxId && options.protectedIds.has(row.canonicalTxId)) {
    return null;
  }
  const usd = typeof row.valueUsd === "number" && Number.isFinite(row.valueUsd) ? row.valueUsd : null;
  const sender = (row.fromAddress ?? "").toLowerCase();
  const fromDuster = Boolean(sender && options.dustSenders?.has(sender));
  if (usd === null && !fromDuster) return null;
  if (usd !== null && usd >= floor) return null;
  const protocols = (row.protocolIds ?? []).filter(Boolean);
  const all = row.primaryProtocolId ? [row.primaryProtocolId, ...protocols] : protocols;
  if (all.length === 0) return null;
  if (all.some((id) => !BARE_TRANSFER_PROTOCOLS.has(id))) return null;
  if (fromDuster) {
    return "Bare transfer from an address seen sending these in bulk \u2014 the shape of a dusting campaign.";
  }
  return `Bare transfer worth ${usd === 0 ? "nothing" : `under $${floor}`} \u2014 the shape of a dusting transfer.`;
}
function withoutDust(rows, read, options = {}) {
  const kept = [];
  let filtered = 0;
  let reason = null;
  for (const row of rows) {
    const why = dustReason(read(row), options);
    if (why === null) {
      kept.push(row);
      continue;
    }
    filtered += 1;
    reason = reason ?? why;
  }
  return { kept, filtered, reason };
}
function deriveDustSenders(rows, read, options = {}) {
  const minRecipients = options.minRecipients ?? DEFAULT_CAMPAIGN_MIN_RECIPIENTS;
  const recipients = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const candidate = read(row);
    const sender = (candidate.fromAddress ?? "").toLowerCase();
    const recipient = (candidate.toAddress ?? "").toLowerCase();
    if (!sender || !recipient || sender === recipient) continue;
    const protocols = (candidate.protocolIds ?? []).filter(Boolean);
    const all = candidate.primaryProtocolId ? [candidate.primaryProtocolId, ...protocols] : protocols;
    if (all.length === 0 || all.some((id) => !BARE_TRANSFER_PROTOCOLS.has(id))) continue;
    const seen = recipients.get(sender) ?? /* @__PURE__ */ new Set();
    seen.add(recipient);
    recipients.set(sender, seen);
  }
  const out = /* @__PURE__ */ new Set();
  for (const [sender, seen] of recipients) {
    if (seen.size >= minRecipients) out.add(sender);
  }
  return out;
}

export { DEFAULT_CAMPAIGN_MIN_RECIPIENTS, DEFAULT_DUST_USD, deriveDustSenders, dustReason, withoutDust };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map